import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';
import { Router } from '@angular/router';
import { ReportingScopeService } from 'src/app/services/reporting-scope.service';
import { AiAnalystScopeService } from 'src/app/services/ai-analyst-scope.service';
import { PermissionService } from 'src/app/services/permission.service';
import { findFirstReadableAiAnalystAdminTab, getAiAnalystAdminRouteConfig } from 'src/app/shared/constants/aiAnalystAdminRouteConfig.constants';

@Component({
  standalone: false,
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {

    userType: number;
    canCreateSubusers = false;
    canViewDataAnalysisPage = false;
    canViewNotifications = false;
    canAccessCorporateReporting = false;
    canOpenAiAnalystAdmin = false;

    private readonly destroy$ = new Subject<void>();

    constructor(private authService: AuthService,
        private router: Router,
        private reportingScopeService: ReportingScopeService,
        private aiAnalystScopeService: AiAnalystScopeService,
        private permissionService: PermissionService) {
    }

    ngOnInit() {
        const currentUser = this.authService.getCurrentUser();
        this.userType = currentUser.userType;
        this.canCreateSubusers = true;
        this.canViewDataAnalysisPage = true;
        this.canViewNotifications = true;
        this.canAccessCorporateReporting = this.reportingScopeService.canAccessCorporateReporting;
        combineLatest([this.aiAnalystScopeService.canAccessAiAnalyst$, this.permissionService.isLoaded$]).pipe(
            filter(([, permissionsLoaded]) => permissionsLoaded),
            takeUntil(this.destroy$),
        ).subscribe({
            next: ([canAccessAiAnalyst]) => this.canOpenAiAnalystAdmin = this.resolveCanOpenAiAnalystAdmin(canAccessAiAnalyst),
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get isAdmin() { return this.userType === SecurityProfileEnum.Admin; }
    get isSuperAdmin() { return this.userType === SecurityProfileEnum.SuperAdmin; }
    get isUser() { return this.userType === SecurityProfileEnum.User; }

    private resolveCanOpenAiAnalystAdmin(canAccessAiAnalyst: boolean): boolean {
        if (!this.isAdmin && !this.isSuperAdmin) {
            return false;
        }
        const tabs = getAiAnalystAdminRouteConfig(this.isSuperAdmin, canAccessAiAnalyst);
        return !!findFirstReadableAiAnalystAdminTab(tabs, objectId => this.permissionService.hasReadPermission(objectId));
    }

    toggleSideMenu() {
        document.querySelector('.body-container')?.classList.toggle('collapsed');
    }

    navigateTo(url: string) {
        this.router.navigate([url]);
    }
}
